import React, { Component } from "react";
import _ from "lodash";
import classNames from "classnames";

class Button extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isDown: false,
      isOver: false,
    };

  }

  render() {
    const { isOver, isDown } = this.state

    const { onClick, className, text, children } = this.props;

    const buttonTopClasses = classNames({
      "onboarding-button-top": true,
      "onboarding-button-top-down": isDown,
      "onboarding-button-top-over": isOver && !isDown,
    });

    return (
      <div className={classNames("onboarding-button", className || "")} onMouseDown={() => this.setState({isDown: true})} onMouseUp={() => this.setState({isDown: false})} onMouseEnter={() => this.setState({isOver: true})} onMouseLeave={() => this.setState({isOver: false, isDown: false})} onClick={onClick}>
        <div className="onboarding-button-bottom">
        </div>
        <div className={buttonTopClasses}>
          <div className="onboarding-button-text">{children || text}</div>
        </div>
      </div>
    );
  }

}

export default Button;
